<template>
    <div style="height: 100%">
        <div class="title">
            <page-title class="search-group flex">
                <span>角色管理</span>
            </page-title>
            <Select
                v-model="selectedAppId"
                filterable
                clearable
                class="select-wrap"
                @on-change="changeApp"
            >
                <Option
                    v-for="item in appList"
                    :value="item.id"
                    :key="item.id"
                >{{ item.name }}</Option
                >
            </Select>
        </div>

        <div class="content" v-if="roleList.length !== 0">
            <div class="left-content height-100-percent">
                <Card class="tree-card height-100-percent">
                    <div slot="title">
                        <enc-tree-search
                            :title="'角色列表'"
                            @handelAdd="addRole"
                            @handelSearch="searchRole"
                        ></enc-tree-search>
                    </div>
                    <div class="tree-block-organ scrollbar">
                        <enc-tree
                            v-if="selectedAppId != ''"
                            ref="encTree"
                            :filter-method="roleFilter"
                            :data-array="roleList"
                            :draggable="true"
                            :render="renderContent"
                            @on-select-change="selectTreeNode"
                            :show-checkbox="false"
                        ></enc-tree>
                    </div>
                </Card>
            </div>
            <div class="right-content height-100-percent">
                <Card class="tree-card height-100-percent">
                    <div
                        v-if="selectedRole.selected"
                        class="one-block height-100-percent"
                    >
                        <div class="top-content">
                            <page-title class="search-group flex">
                                <span>{{
                                    selectedRole ? selectedRole.name : '-'
                                }}</span>
                                <Tag color="warning"
                                >用户数 {{ roleUserCount }}</Tag
                                >
                            </page-title>
                            <div class="title-msg">
                                备注信息：{{
                                    selectedRole ? selectedRole.remark : '-'
                                }}
                            </div>
                        </div>
                        <div class="bottom-content">
                            <Tabs
                                value="permission"
                                v-model="curTab"
                                class="tabs-wrap height-100-percent"
                                @on-click="changeTab"
                            >
                                <TabPane
                                    label="权限"
                                    name="permission"
                                    class="tab-one"
                                >
                                    <user-tab
                                        ref="userTab"
                                        :authorityListData="authorityListData"
                                        :initDataObj="initDataObj"
                                        :selectData="selectData"
                                        :isEditParent="isEdit"
                                        :selectedAppId="selectedAppId"
                                        :selectedRole="selectedRole"
                                        @changeMenuItem="changeMenuItem"
                                        @changeIsEdit="changeIsEdit"
                                        @recoverInitData="recoverInitData"
                                        @updateEditInfo="updateEditInfo"
                                        @requestTree="requestTree"
                                    ></user-tab>
                                </TabPane>
                                <TabPane label="成员" name="member">
                                    <div
                                        v-if="memberList.isShow"
                                        class="scrollbar tab-height"
                                    >
                                        <member-list
                                            :obj="memberList"
                                        ></member-list>
                                        <Page
                                            class="margin-tb-10 text-left class-page"
                                            :current="memberList.curPage"
                                            :page-size="memberList.pageSize"
                                            :total="memberList.total"
                                            size="small"
                                            show-total
                                            show-elevator
                                            show-sizer
                                            @on-change="changePage"
                                            @on-page-size-change="
                                                changePageSize
                                            "
                                        />
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <div v-else class="img-wrap flex-center height-100-percent">
                        <img
                            :src="require('./../../assets/noRoleData.png')"
                            alt=""
                            style="padding-bottom: 30px"
                        />
                    </div>
                </Card>
            </div>
        </div>
        <div v-else-if="roleList.length === 0" class="content-no-data">
            <div class="container-wrap height-100-percent flex flex-center">
                <div class="text-center">
                    <img
                        :src="require('./../../assets/noRoleData.png')"
                        alt=""
                        width="500px"
                        style="padding-bottom: 30px"
                    />
                    <div
                        class="com-wrap"
                        @click="addRole"
                        v-if="this.selectedAppId"
                    >
                        <Button type="primary" icon="md-add-circle"
                        >添加角色</Button
                        >
                    </div>
                </div>
            </div>
        </div>
        <Modal
            v-model="roleModal"
            :loading="true"
            @on-cancel="roleCancel"
            :title="isAddOrEdit === 'edit' ? '编辑角色' : '新增角色'"
        >
            <Form
                ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate"
                :label-width="80"
            >
                <FormItem label="角色名称" prop="roleName">
                    <Input
                        v-model="formValidate.roleName"
                        placeholder="请输入"
                    />
                </FormItem>
                <FormItem label="备注" prop="remark">
                    <Input v-model="formValidate.remark" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="roleCancel" style="margin-left: 8px"
                >取消</Button
                >
                <Button type="primary" @click="handleSubmit('formValidate')"
                >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import api from '../../common/api'
import EncTreeSearch from '../../components/EncTreeSearch.vue'
import EncTree from '../../components/EncTree.vue'
import eventMix from './mix/eventMix'
import requestMix from './mix/requestMix'
import UserTab from './components/authority/authorityContainer.vue'
import MemberList from './components/member/list.vue'

export default {
    name: 'roleManager',
    mixins: [eventMix, requestMix],
    data() {
        return {
            roleModal: false,
            loading: false,
            roleFilterStr: '',
            curTab: 'permission',
            formValidate: {
                roleName: '',
                remark: ''
            },
            ruleValidate: {
                roleName: [
                    {
                        required: true,
                        message: '请输入角色名称',
                        trigger: 'blur'
                    }
                ],
                remark: [
                    {
                        required: false,
                        message: 'Mailbox cannot be empty',
                        trigger: 'blur'
                    }
                ]
            },
            appList: [],
            selectedApp: {},
            selectedAppId: '',
            roleList: [],
            selectedRole: {},
            roleUserCount: 1,
            isAddOrEdit: 'add',
            classView: {
                title: '字段分类权限',
                data: []
            },
            memberList: {
                isShow: true,
                curPage: 1,
                pageSize: 10,
                total: 150,
                data: {}
            },
            authorityListData: [],
            menuItemIndex: 0,
            initDataObj: {},
            initDataObjCopy: {},
            selectData: {},
            isEdit: false,
            dropDownVisible: false,
            prevTreeNode: {}
        }
    },
    watch: {
        selectedAppId: {
            handler() {
                this.selectedApp = this.appList.find((item) => item.id === this.selectedAppId)
            }
        }
    },
    created() {
        this.getappList()
    },
    components: {
        EncTreeSearch,
        EncTree,
        UserTab,
        MemberList
        // Hierarchical,
        // Classify
    },
    methods: {
        addRole() {
            console.log(this.selectedAppId)
            this.roleModal = true
            this.isAddOrEdit = 'add'
        },
        searchRole(val) {
            this.roleFilterStr = val
            this.$refs.encTree.filter(this.roleFilterStr)
        },
        changeTab(name) {
            if (name === 'permission') {
                this.initDataObj = {}
                this.initDataObjCopy = {}
                this.selectData = {}
                this.isEdit = false
                // this.getRoleUserCount()
                // 请求对应角色下的“权限”数据
                // this.getAuthorityList()
            } else if (name === 'member') {
                this.memberList.isShow = true
                this.getUserList()
            }
            this.curTab = name
        },
        changePageSize(val) {
            this.memberList.pageSize = val
            this.getUserList()
        },
        changePage(val) {
            this.memberList.curPage = val
            this.getUserList()
        },
        // =============================
        // eslint-disable-next-line no-unused-vars
        renderContent(h, { root, node, data }) {
            const self = this
            return h('span', {}, [
                h(
                    'span',
                    {
                        domProps: {
                            title: data.name
                        },
                        class: 'tree-node-text'
                    },
                    data.name
                ),
                h(
                    'Dropdown',
                    {
                        style: {
                            fontSize: '20px',
                            position: 'absolute',
                            right: '0px'
                        },
                        props: {
                            trigger: 'custom',
                            visible: data.dropDownVisible,
                            placement: 'bottom-end',
                            'stop-propagation': true
                        },
                        on: {
                            'on-clickoutside': () => {
                                data.dropDownVisible = false
                            }
                        }
                    },
                    [
                        h('Icon', {
                            props: {
                                type: 'md-more'
                            },
                            style: {
                                fontSize: '20px',
                                position: 'absolute',
                                right: '0px',
                                top: '8px'
                            },
                            on: {
                                click: (e) => {
                                    e.stopPropagation()
                                    if (self.prevTreeNode) {
                                        self.prevTreeNode.dropDownVisible = false
                                    }
                                    data.dropDownVisible = true
                                    self.prevTreeNode = data
                                }
                            }
                        }),
                        h(
                            'DropdownMenu',
                            {
                                slot: 'list'
                            },
                            [
                                h(
                                    'DropdownItem',
                                    {
                                        props: {
                                            name: 'edit'
                                        },
                                        nativeOn: {
                                            click: ($event) => {
                                                $event.stopPropagation()
                                                this.treeDropDownClick('edit', { root, node, data })
                                            }
                                        }
                                    },
                                    '编辑'
                                ),
                                h(
                                    'DropdownItem',
                                    {
                                        props: {
                                            name: 'delete'
                                        },
                                        nativeOn: {
                                            click: ($event) => {
                                                $event.stopPropagation()
                                                this.treeDropDownClick('delete', { root, node, data })
                                            }
                                        }
                                    },
                                    '删除'
                                )
                            ]
                        )
                    ]
                )
            ])
        },
        // eslint-disable-next-line max-params
        treeDropDownClick(name, { root, node, data }) {
            // eslint-disable-next-line default-case
            switch (name) {
            case 'add':
                this.selectedRole = {}
                this.parentRoleNode = data
                this.parentRoleNode.children = this.parentRoleNode.children || []
                this.roleModal = true
                break
            case 'edit':
                this.parentRoleNode = node.node
                this.selectedRole = JSON.parse(JSON.stringify(node.node))
                this.formValidate.roleName = this.selectedRole.name
                this.formValidate.remark = this.selectedRole.remark
                this.roleModal = true
                this.isAddOrEdit = 'edit'
                break
            case 'delete':
                this.selectedRole = node.node
                this.$Modal.confirm({
                    title: '提示',
                    loading: true,
                    content: `<div>您确定要删除角色 ${this.selectedRole.name} 吗？</div>`,
                    onOk: () => {
                        api.deleteRole([this.selectedRole.id])
                            .then((res) => {
                                if (res.resultCode === 0) {
                                    this.$Message.success('删除成功')
                                    const nodeIndex = root.findIndex((el) => el === node)
                                    const parentKey = root[nodeIndex].parent
                                    const parentNode = root.find((el) => el.nodeKey === parentKey)
                                    if (parentNode) {
                                        const parent = parentNode.node
                                        const index = parent.children.indexOf(data)
                                        parent.children.splice(index, 1)
                                        if (!parent.children.length) {
                                            parent.expand = false
                                        }
                                    } else {
                                        const i = this.$refs.encTree.treeData.findIndex((el) => el.id === data.id)
                                        this.$refs.encTree.treeData.splice(i, 1)
                                    }
                                } else {
                                    this.$Message.warning(res.resultMessage || '删除失败')
                                }
                                this.$Modal.remove()
                            })
                            .catch((e) => {
                                this.$Message.error(e.resultMessage || '删除异常')
                                this.$Modal.remove()
                            })
                    }
                })
                break
            }
        },
        roleFilter(node) {
            return node.name.indexOf(this.roleFilterStr) > -1
        },
        selectTreeNode(arr, cur) {
            this.selectedRole = cur
            this.isEdit = false
            if (this.curTab === 'permission' && !this.isEdit) {
                this.initDataObj = {}
                this.initDataObjCopy = {}
                this.selectData = {}
                this.isEdit = false
                if (this.selectedRole.selected) {
                    const that = this
                    this.$nextTick(() => {
                        that.$refs.userTab.init(0)
                    })
                    // 请求对应角色下的“权限”数据
                    this.getAuthorityList()
                }
            } else if (this.curTab === 'member' && !this.isEdit) {
                this.getUserList()
            }
            this.getRoleUserCount()
        },
        changeApp(val) {
            this.selectedAppId = val
            this.authorityListData = []
            if (this.selectedAppId) {
                this.getRoleListData().then((res1) => {
                    if (res1.length > 0) {
                        const obj = res1[0]
                        this.selectedRole = obj
                        this.selectedRole.selected = true
                    }
                    this.getRoleUserCount()
                    this.getAuthorityList()
                })
            } else {
                this.roleList = []
            }
        },
        changeMenuItem(val) {
            this.menuItemIndex = val
            // if (this.isEdit) {
            //     this.getTree()
            // }
            this.getTree()
        },
        changeIsEdit(val) {
            this.isEdit = val
        },
        // 点击取消时，initDataObj恢复初始状态
        recoverInitData() {
            console.log('11111')
            this.initDataObj = JSON.parse(JSON.stringify(this.initDataObjCopy))
        },
        updateEditInfo(obj) {
            const param = {
                newMenuIdList: obj.newMenuIdList,
                oldMenuIdList: obj.oldMenuIdList,
                roleId: this.selectedRole.id === undefined ? 0 : this.selectedRole.id
            }
            this.updateAuthorityInfo(param)
        },
        requestTree() {
            this.getTree()
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ .ivu-tabs-bar {
    .ivu-tabs-nav {
        float: right;
    }
}
/deep/ .search-group {
    .ivu-select {
        margin-left: 36px;
    }
    .ivu-select-dropdown {
        max-width: 200px;
        overflow-x: hidden;
    }
    .ivu-tag {
        margin-left: 42px;
    }
}
.class-page {
    position: absolute;
    bottom: 0;
    width: 100%;
}
.title-msg {
    margin-top: 18px;
}
.tree-block-organ {
    height: calc(100vh - 220px);
    overflow-x: hidden;
}
.tab-height {
    position: relative;
    height: calc(100vh - 280px);
}
/deep/ .tree-node-text {
    text-overflow: ellipsis;
    position: relative;
    width: 90%;
    overflow: hidden;
    display: inline-block;
}
.layout-main-content {
    .title {
        display: flex;
        align-items: center;
        .select-wrap {
            margin-left: 40px;
            width: 174px;
        }
        .icon {
            width: 8px;
            height: 24px;
            background: var(--theme-menu-item-selected-bg-color);
            margin-right: 12px;
        }
        .tips {
            border-radius: 14px;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            padding: 3px 20px;
            margin-left: 30px;
        }
    }
    .content {
        height: calc(100% - 53px);
        margin-top: 20px;
        .left-content {
            width: 296px;
            margin-right: 12px;
            float: left;
            .tree-card {
                /deep/ .ivu-card-body {
                    height: 92%;
                    .tree-block {
                        height: 100%;
                        min-height: 90px;
                    }
                }
            }
        }
        .right-content {
            width: calc(100% - 296px - 12px);
            float: left;
            .tree-card {
                /deep/ .ivu-card-body {
                    height: 100%;
                    padding: 24px 20px 20px 32px;
                    .one-block {
                        .top-content {
                            .head-title {
                                font-size: 24px;
                                font-weight: 600;
                                color: var(--base-font-color);
                                line-height: 33px;
                                padding-bottom: 18px;
                                /deep/ .ivu-tag {
                                    border-radius: 14px;
                                }
                            }
                            .remark {
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #505356;
                                line-height: 20px;
                            }
                        }
                        .bottom-content {
                            padding: 0px;
                            height: calc(100% - 30px);
                            position: relative;
                            .tabs-wrap {
                                margin-top: -18px;
                                /deep/ .ivu-tabs-tab {
                                    font-family: PingFangSC-Semibold,
                                        PingFang SC;
                                    font-weight: 600;
                                    color: #505356;
                                }
                                // /deep/ .ivu-tabs-bar {
                                //     .ivu-tabs-nav {
                                //         float: right;
                                //     }
                                // }
                                /deep/ .ivu-tabs-content {
                                    height: 90%;
                                }
                            }
                        }
                    }
                }
            }
        }
        .container-wrap {
            height: 100%;
            flex-wrap: wrap;
        }
    }
    .content-no-data {
        height: 90vh;
        margin-top: 20px;
        .container-wrap {
            .com-wrap {
                width: 100%;
            }
        }
    }
}
</style>
